import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Calendar from 'react-calendar'
import moment from 'moment'

const CustomCalendar = ({ availableDates, title, handleChange }) => {

    const [selectedDate, setDate] = useState(null)

    const handleSetDate = value => {
        setDate(value)
        if (handleChange) {
            handleChange(value)
        }
    }

    const tileDisabled = ({ activeStartDate, date, view }) => {
        let dates = availableDates.filter(item => {
            return item.date === moment(date).format('YYYY-MM-DD')
        })
        return dates.length === 0;
    }

    return (
        <div className="custom-calendar">
            {title && <p className="bold m-0 p-3">{title}</p>}
            <Calendar
                onChange={handleSetDate}
                value={selectedDate}
                nextLabel={<NextLabel />}
                prevLabel={<PrevLabel />}
                maxDetail="month"
                minDetail="month"
                tileDisabled={tileDisabled}
                minDate={new Date()}
            />
        </div>
    )

}

export default CustomCalendar;

CustomCalendar.propTypes = {
    availableDates: PropTypes.array.isRequired,
    handleChange: PropTypes.func,
    title: PropTypes.string
}

const NextLabel = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M10.7071 16.7071L14.7071 12.7071C15.0976 12.3166 15.0976 11.6834 14.7071 11.2929L10.7071 7.29289C10.3166 6.90237 9.68342 6.90237 9.29289 7.29289C8.90237 7.68342 8.90237 8.31658 9.29289 8.70711L12.5858 12L9.29289 15.2929C8.90237 15.6834 8.90237 16.3166 9.29289 16.7071C9.68342 17.0976 10.3166 17.0976 10.7071 16.7071Z"
                fill="#004346"/>
        </svg>
    )
}

const PrevLabel = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M13.2929 7.29289L9.29289 11.2929C8.90237 11.6834 8.90237 12.3166 9.29289 12.7071L13.2929 16.7071C13.6834 17.0976 14.3166 17.0976 14.7071 16.7071C15.0976 16.3166 15.0976 15.6834 14.7071 15.2929L11.4142 12L14.7071 8.70711C15.0976 8.31658 15.0976 7.68342 14.7071 7.29289C14.3166 6.90237 13.6834 6.90237 13.2929 7.29289Z" fill="#004346"/>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./resources/js/components/CustomCalendar.js